/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import {
    ContentSection,
    ModalTitle,
    SelectUserContent,
    TitleSection,
    useToken,
} from "trux"
import { useGetUserRelationsQuery } from "../../generated/graphql"

export const SelectUser = ({ onClose, selectFamilyMember }) => {
    let user = useSelector((state) => state.user.value)

    const token = useToken("SelectUser")
    const tokenReady = token != null

    const {
        data: relations,
        loading: relationsLoading,
        error: relationsError,
    } = useGetUserRelationsQuery({
        variables: {
            to_user_id: user?.user_id,
            token: token,
            include_self: true,
        },
        skip: !tokenReady,
    })

    useEffect(() => {
        if (relations?.userRelations?.length === 1) {
            selectFamilyMember(relations.userRelations[0].user)
        }
    }, [relations, selectFamilyMember])

    return (
        <>
            <TitleSection onCloseClick={onClose}>
                <ModalTitle content="Who is this moment for?" />
            </TitleSection>
            <ContentSection>
                {relations?.userRelations && (
                    <SelectUserContent
                        userRelations={relations.userRelations}
                        selectFamilyMember={(familyMember) =>
                            selectFamilyMember(familyMember)
                        }
                    />
                )}
            </ContentSection>
        </>
    )
}
